<template>
  <WdsStack direction-column class="tw-gap-7">
    <FreelancerIntroduction />

    <div class="tw-flex tw-flex-col md:tw-flex-row tw-gap-7">
      <div class="tw-flex tw-flex-col tw-gap-7 tw-w-full md:tw-w-1/2">
        <MyContracts />
        <WorkerClients />
      </div>

      <div class="tw-flex tw-flex-col tw-gap-7 tw-w-full md:tw-w-1/2">
        <MyTasks />
        <SharedWithYou />
      </div>
    </div>
  </WdsStack>
</template>

<script setup lang="ts">
import { WdsStack } from '@worksome/wds-components'
import MyContracts from '@/components/Dashboard/Widgets/MyContracts.vue'
import FreelancerIntroduction from '@/components/Dashboard/FreelancerIntroduction.vue'
import MyTasks from '@/components/Dashboard/Widgets/MyTasks.vue'
import SharedWithYou from '@/components/Dashboard/Widgets/SharedWithYou.vue'
import WorkerClients from '@/components/Dashboard/Widgets/Clients/WorkerClients.vue'
</script>
